import { forwardRef, type Ref, type SVGProps } from "react";

function SvgHelpOutlined(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 21 20" {...props}>
      <path
        d="M9.5 16H11.5V14H9.5V16ZM10.5 0C4.98 0 0.5 4.48 0.5 10C0.5 15.52 4.98 20 10.5 20C16.02 20 20.5 15.52 20.5 10C20.5 4.48 16.02 0 10.5 0ZM10.5 18C6.09 18 2.5 14.41 2.5 10C2.5 5.59 6.09 2 10.5 2C14.91 2 18.5 5.59 18.5 10C18.5 14.41 14.91 18 10.5 18ZM10.5 4C8.29 4 6.5 5.79 6.5 8H8.5C8.5 6.9 9.4 6 10.5 6C11.6 6 12.5 6.9 12.5 8C12.5 10 9.5 9.75 9.5 13H11.5C11.5 10.75 14.5 10.5 14.5 8C14.5 5.79 12.71 4 10.5 4Z"
        fill="currentColor"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgHelpOutlined);
export default ForwardRef;
